import { FormattedNumber as IntlFormattedNumber } from 'react-intl'
import moment from 'moment'

import { withLocale } from '@i18n/utils'
import enCaMessages from './locale/en-ca.json'
import enGbMessages from './locale/en-gb.json'
import enUSMessages from './locale/en-us.json'
import enMessages from './locale/en.json'
import esEsMessages from './locale/es-es.json'
import frBeMessages from './locale/fr-be.json'
import frCaMessages from './locale/fr-ca.json'
import frFrMessages from './locale/fr-fr.json'
import nlBeMessages from './locale/nl-be.json'
import ptBrMessages from './locale/pt-br.json'
import esCoMessages from './locale/es-co.json'

// Import locales for Moment.js
import 'moment/locale/be' // Belgium [be]
import 'moment/locale/cs' // Czech [cs]
import 'moment/locale/de-at' // German (Austria) [de-at]
import 'moment/locale/de' // German
import 'moment/locale/en-ca' // English (Canada) [en-ca]
import 'moment/locale/en-gb' // English (United Kingdom) [en-gb]
import 'moment/locale/es' // Spanish [es]
import 'moment/locale/fr-ca' // French (Canada) [fr-ca]
import 'moment/locale/fr' // French [fr]
import 'moment/locale/lb' // Luxembourgish [lb]
import 'moment/locale/nl-be' // Dutch (Belgium) [nl-be]
import 'moment/locale/nl' // Dutch [nl]
import 'moment/locale/sk' // Slovak [sk]
import 'moment/locale/pt-br' // Portugese (Brazil) [pt-br]

// Override [en-gb]
moment.updateLocale('en-gb', {
    longDateFormat: {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY h:mm A',
        LLLL: 'dddd, D MMMM YYYY h:mm A',
    },
})

// Override [fr-ca]
moment.updateLocale('fr-ca', {
    longDateFormat: {
        LT: 'HH[h]mm',
        L: 'DD/MM/YYYY',
    },
})

export const messages = {
    en: enMessages,
    'en-ca': enCaMessages,
    'en-gb': enGbMessages,
    'en-us': enUSMessages,
    'fr-ca': frCaMessages,
    'fr-be': frBeMessages,
    fr: frFrMessages,
    'es-es': esEsMessages,
    'nl-be': nlBeMessages,
    'pt-br': ptBrMessages,
    'es-co': esCoMessages,
    // Add other languages here as needed
}

// Translations are served at runtime from /locale/*.json (a ConfigMap in deployed
// environments, see deployment/indigo-web/templates/translation-sync.yaml). The bundled
// `messages` above are only a fallback for when that fetch fails or hasn't resolved yet.
export const resolveMessages = (locale, fetched) =>
    fetched && Object.keys(fetched).length ? fetched : messages[locale]

export const FormattedNumber = withLocale(IntlFormattedNumber)
